<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show === true">เปลี่ยนสถานะเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มตำแหน่งเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขตำแหน่งเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="d-flex justify-space-between card_role_team">
            <div class="mr-1">
                <v-form ref="form" @submit.prevent="addRoleTeam()">
                    <div class="mb-2">
                        <h3>{{ edit_id !== null ? 'แก้ไข' : 'เพิ่ม'}}ตำแหน่ง</h3>
                    </div>
                    <v-text-field label="ชื่อตำแหน่ง" v-model="name" color="#038cc1" :rules="[v => !!v || 'กรุณากรอกชื่อตำแหน่ง']" required outlined></v-text-field>
                    <!-- <v-select :items="permit_list" item-text="name" item-value="id" v-model="permit_id" label="สิทธิ์การเข้าใช้งาน" :rules="[v => !!v || 'กรุณาเลือกสิทธิ์การเข้าใช้งาน']" color="primary" required outlined>
                    </v-select> -->
                    <v-btn class="title_font_rolelist white--text grad-primary-bg" width="100%" height="50" type="submit">
                        บันทึก
                    </v-btn>
                </v-form>
            </div>
            <div class="ml-1">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" color="primary" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="data" :search="search">
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>{{dataDetail.item.number}}</td>
                                <td>{{dataDetail.item.name}}</td>
                                <!-- <td>{{dataDetail.item.permit}}</td> -->
                                <td>
                                    <span>
                                        <v-switch color="#038cc1" v-model="dataDetail.item.status" @click="changeStatus(dataDetail.item.id)"></v-switch>
                                    </span>
                                </td>
                                <td>

                                    <span class="edit_data_rolelist" @click="detailRoleTeam(dataDetail.item.id)">
                                        <v-icon dark right color="grey">mdi-pencil-box-outline</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            alert_show: false,
            alert_show_add: false,
            alert_show_edit: false,
            //permit_list: [],
            edit_id: null,
            name: null,
            //permit_id: null,
            search: '',
            headers: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },

                {
                    text: 'ตำแหน่ง',
                    value: 'name'
                },
                // {
                //     text: 'สิทธิการใช้งาน',
                //     value: 'permit'
                // },
                {
                    text: 'สถานะ',
                    value: 'status'
                },
                {
                    text: 'จัดการ',
                    value: 'action'
                },
            ],
            data: [],
        }
    },
    methods: {
        async roleTeamList() {
            HTTP.get('/rank/list-rank', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        for (let index = 0; index < response.data.listRank.length; index++) {
                            response.data.listRank[index].number = index + 1
                        }
                        this.data = response.data.listRank
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

            // await HTTP.get('/rank/list-permit', {
            //         headers: {
            //             "Authorization": `Bearer ${this.$store.state.token}`
            //         }
            //     })
            //     .then((response) => {
            //         if (response.data.successful === true) {
            //             this.permit_list = response.data.permit_list
            //             this.loading_page = false
            //         }

            //     }).catch((error) => {
            //         if (error.response.status === 401) {
            //             this.$store.commit('logOutSuccess')
            //             this.$router.push('/login')
            //         }
            //     })

        },
        async changeStatus(id) {
            HTTP.post('/rank/status-update', {
                    id: id
                }, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.alert_show = true
                        setTimeout(() => this.alert_show = false, 5000)
                    }

                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async detailRoleTeam(id) {
            HTTP.get('/rank/edit/' + id, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.edit_id = response.data.rankDetail.id
                        this.name = response.data.rankDetail.name
                        //this.permit_id = response.data.rankDetail.permit
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
        async addRoleTeam() {
            if (this.$refs.form.validate()) {
                this.loading_page = true
                if (this.edit_id === null) {
                    HTTP.post('/rank/create', {
                            name: this.name,
                            //permit_id: this.permit_id,
                        }, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                        .then((response) => {
                            if (response.data.successful === true) {
                                this.name = null
                                //this.permit_id = null
                                this.roleTeamList()
                                this.alert_show_add = true
                                setTimeout(() => this.alert_show_add = false, 5000)
                            }

                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })
                } else {
                    HTTP.post('/rank/update', {
                            id: this.edit_id,
                            name: this.name,
                            //permit_id: this.permit_id,
                        }, {
                            headers: {
                                "Authorization": `Bearer ${this.$store.state.token}`
                            }
                        })
                        .then((response) => {
                            if (response.data.successful === true) {
                                this.edit_id = null
                                this.name = null
                                //this.permit_id = null
                                this.roleTeamList()
                                this.alert_show_edit = true
                                setTimeout(() => this.alert_show_edit = false, 5000)
                            }

                        }).catch((error) => {
                            if (error.response.status === 401) {
                                this.$store.commit('logOutSuccess')
                                this.$router.push('/login')
                            }
                        })

                }
            }
        }
    },
    mounted() {
        this.roleTeamList()
    }
}
</script>
